/*
 * OAF – Required stain / paint selection
 * Blocks Add to cart, Buy it now and checkout while a required, visible
 * finish field (e.g. "Red Oak Stain", "Qtr Sawn White Oak", "Paint Colors")
 * is still on its "Select Stain" / "Select Paint" placeholder choice.
 * "Aged Stain Colors" is an optional upcharge and is never enforced.
 * Matches fields by label (not Itoris option IDs) so it works on every product.
 */
(function () {
  "use strict";

  var PLACEHOLDER = /^\s*select\b/i;          // "Select Stain", "Select Paint", ...
  var OPTIONAL_LABEL = /aged/i;               // Aged Stain Colors = optional upgrade
  var CART_PLACEHOLDER = /^\s*select\s+(stain|paint)\b/i;
  var BOX_ID = "oaf-required-stain-error";

  function clean(text) {
    return String(text || "").replace(/\*/g, "").replace(/\s+/g, " ").trim();
  }

  function isHidden(node) {
    return node.classList.contains("ihidden") || !!node.closest(".ihidden");
  }

  function selectedText(field) {
    var select = field.querySelector("select");
    if (select && select.selectedIndex > -1) {
      return clean(select.options[select.selectedIndex].textContent);
    }
    var input = field.querySelector("input[type=radio]:checked, input[type=checkbox]:checked");
    if (!input) return "";
    var label = field.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    return clean(label ? label.textContent : input.value);
  }

  // Returns {field, label} for the first required finish field left on a placeholder.
  function missingFinish() {
    var root = document.getElementById("itoris_dynamicproductoptions");
    if (!root) return null;
    var fields = root.querySelectorAll(".field");
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (field.classList.contains("choice")) continue;
      var label = field.querySelector(":scope > label");
      if (!label || !label.classList.contains("required")) continue;
      var name = clean(label.textContent);
      if (OPTIONAL_LABEL.test(name) || isHidden(field)) continue;
      if (PLACEHOLDER.test(selectedText(field))) return { field: field, label: name };
    }
    return null;
  }

  function productMessage(name) {
    var kind = /paint/i.test(name) ? "paint color" : "stain";
    return "Please choose a " + kind + " for “" + name + "” before adding this item to your cart.";
  }

  function show(text, field) {
    var box = document.getElementById(BOX_ID);
    if (!box) {
      box = document.createElement("div");
      box.id = BOX_ID;
      box.setAttribute("role", "alert");
      box.tabIndex = -1;
      box.style.cssText = "padding:14px;margin:14px 0;border:1px solid #b42318;background:#fff4f2;color:#8c1d18;font-size:16px;line-height:1.5";
    }
    box.textContent = text;
    if (field) {
      var details = field.querySelector("details");
      if (details) details.open = true;
      field.parentNode.insertBefore(box, field);
      field.scrollIntoView({ block: "center" });
    } else {
      var anchor = document.querySelector(".cart__footer, #main-cart-footer, main");
      if (anchor) anchor.prepend(box); else document.body.prepend(box);
      box.scrollIntoView({ block: "center" });
    }
    box.focus({ preventScroll: true });
  }

  function clear() {
    var box = document.getElementById(BOX_ID);
    if (box) box.remove();
  }

  function block(event, text, field) {
    event.preventDefault();
    event.stopImmediatePropagation();
    show(text, field);
  }

  /* ---------- Product page ---------- */
  function isPurchaseControl(target) {
    var control = target.closest('[type="submit"], [dpo_add2cart], .shopify-payment-button, .buy-now-container');
    if (!control && /buy it now|add to cart/i.test(target.textContent || "")) control = target.closest("button, a");
    return control && (control.closest("product-form") || control.closest("#MainContent")) ? control : null;
  }

  function checkProduct(event) {
    var missing = missingFinish();
    if (missing) block(event, productMessage(missing.label), missing.field);
  }

  /* ---------- Cart page ---------- */
  var cartProblems = [];

  function refreshCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart") + ".js", {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        cartProblems = (cart.items || []).filter(function (item) {
          var props = item.properties || {};
          return Object.keys(props).some(function (key) {
            return !OPTIONAL_LABEL.test(key) && CART_PLACEHOLDER.test(String(props[key] || ""));
          });
        }).map(function (item) { return item.product_title || item.title; });
        if (!cartProblems.length) clear();
      })
      .catch(function () {});
  }

  function cartMessage() {
    var names = cartProblems.join(", ");
    return "A stain or paint color still needs to be chosen for: " + names +
      ". Click “Configure” on that item to pick a finish, then check out.";
  }

  function isCheckoutControl(target) {
    return target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], #checkout');
  }

  /* ---------- Wiring ---------- */
  var onProduct = !!document.getElementById("itoris_dynamicproductoptions") || /\/products\//.test(location.pathname);

  window.addEventListener("click", function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (onProduct && isPurchaseControl(target)) { checkProduct(event); return; }
    if (isCheckoutControl(target) && cartProblems.length) {
      block(event, cartMessage(), null);
      refreshCart();
    }
  }, true);

  window.addEventListener("submit", function (event) {
    var form = event.target;
    if (onProduct && form.matches('form[action*="/cart/add"]')) { checkProduct(event); return; }
    if (form.matches('form[action*="/cart"]') && (!event.submitter || event.submitter.name === "checkout") && cartProblems.length) {
      block(event, cartMessage(), null);
      refreshCart();
    }
  }, true);

  document.addEventListener("change", function () {
    if (onProduct && !missingFinish()) clear();
    setTimeout(refreshCart, 800);
  });
  document.addEventListener("click", function (event) {
    var t = event.target instanceof Element ? event.target : null;
    if (t && t.closest("cart-remove-button, .cart-remove-button, [href*='/cart/change'], .quantity__button")) setTimeout(refreshCart, 1200);
  });

  refreshCart();
})();
